/*=========================================================================================
  File Name: actions.js
  Namespace: quizzes
  Description: Vuex Store - Quiz actions
==========================================================================================*/
import {
  getQuiz,
  createQuiz,
  editQuiz,
  listQuizzes,
  createQuestion,
  editQuestion,
  deleteQuestion,
  createAnswer,
  editAnswer,
  deleteAnswer,
  uploadFile,
  insertQuizzesAfterVideos
} from '@/services/quizzes.service'

import {
  adaptQuizToStore
} from '@/services/adapters/quizAdapter.js'

const actions = {
  async getQuizAction({ commit }, { quizId }) {
    const response = await getQuiz({
      quizId
    })
    if (response) {
      commit('STORE_CURRENT_QUIZ', response.quiz)
      // save the questions
      commit('STORE_CURRENT_QUESTIONS', response.questions)
      // save the answers
      commit('STORE_CURRENT_ANSWERS', response.answers)
    }
    return response.quiz
  },
  async getAllQuizzes({
    commit,
    rootGetters
  }, params = {}) {
    params.company = rootGetters['app/getSelectedCompanyName'].toLowerCase()
    const response = await listQuizzes(params)
    if (response) {
      commit('STORE_LIST_QUIZZES', response)
    }
    return response
  },
  async saveQuizToApi({
    state, commit, getters, rootGetters
  }) {
    let response
    if (state.quiz.id) {
      response = await editQuiz({
        ...getters.getCurrentQuiz,
        questions: getters.getCurrentQuestions,
        answers: getters.getCurrentAnswers,
        quizId: getters.getCurrentQuiz.id,
        company: rootGetters['app/getSelectedCompanyName']
      })
    } else {
      response = await createQuiz({
        ...getters.getCurrentQuiz,
        company: rootGetters['app/getSelectedCompanyName']
      })
    }
    if (response) {
      // Is this necessary? Maybe to do something with ids when edit?
      commit('STORE_CURRENT_QUIZ', response.quiz)
    }
    return response.quiz
  },
  async createQuestion({
    commit, getters
  }, payload) {
    let response
    // delete temp ID
    delete payload.question.id
    response = await createQuestion({
      quizId: getters.getCurrentQuiz.id,
      question: payload.question
    })
    if (response) {
      response.answers = []
      commit('STORE_QUESTION', response)
    }
    return response
  },
  async editQuestion({
    commit,
    getters
  }, payload) {
    let response
    response = await editQuestion({
      quizId: getters.getCurrentQuiz.id,
      questionId: payload.question.id,
      question: payload.question
    })
    if (response) {
      response.answers = payload.question.answers
      commit('STORE_QUESTION', response)
    }
    return response
  },
  async deleteQuestionAction({
    commit,
    getters
  }, { index, deleteFunc }) {
    let response
    commit('DELETE_QUESTION', {
      index: index,
      deleteFunc: deleteFunc
    })
    response = await deleteQuestion({
      quizId: getters.getCurrentQuiz.id,
      questionId: index
    })
    return response
  },

  // ANSWERS

  async createAnswer({
    commit,
    getters
  }, payload) {
    let response
    // delete temp ID
    delete payload.answer.id
    response = await createAnswer({
      quizId: getters.getCurrentQuiz.id,
      questionId: payload.questionId,
      answer: payload.answer
    })
    if (response) {
      commit('STORE_ANSWER', {
        answer: response,
        questionId: payload.questionId,
        addFunc: payload.addFunc
      })
    }
    return response
  },
  async editAnswer({
      commit,
      getters
    }, payload) {
      let response
      response = await editAnswer({
        quizId: getters.getCurrentQuiz.id,
        questionId: payload.questionId,
        answerId: payload.answerId,
        answer: payload.answer
      })
      if (response) {
        commit('STORE_ANSWER', {
          answer: response,
          questionId: payload.questionId
        })
      }
      return response
    },
  async deleteAnswerAction({
    commit,
    getters
  }, {
    answerId,
    questionId,
    deleteFunc
  }) {
    let response
    commit('DELETE_ANSWER', {
      questionId: questionId,
      answerId: answerId,
      deleteFunc: deleteFunc
    })
    response = await deleteAnswer({
      quizId: getters.getCurrentQuiz.id,
      questionId: questionId,
      answerId: answerId
    })
    return response
  },
  saveQuizToEdit({
    commit
  }, quiz) {
    const adaptedQuiz = adaptQuizToStore({
      data: quiz
    })
    commit('STORE_CURRENT_QUIZ', adaptedQuiz.quiz)
    // save the questions
    commit('STORE_CURRENT_QUESTIONS', adaptedQuiz.questions)
    // save the answers
    commit('STORE_CURRENT_ANSWERS', adaptedQuiz.answers)
  },
  resetCurrentQuiz({ commit }) {
    commit('RESET_CURRENT_QUIZ')
  },
  async uploadQuizCSV({
    rootGetters
  }, formData) {
    const response = await uploadFile({
      file: formData,
      company: rootGetters['app/getSelectedCompanyName']
    })
    return response
  },
  async insertQuizzesAfterVideos(_, mappings) {
    return insertQuizzesAfterVideos(mappings)
  },
  saveQuizToEntries({
    commit
  }, quiz) {
    commit('STORE_QUIZ_TO_LIST', {
      [quiz.id]: quiz
    })
  },
}

export default actions
